import Layout from "../parts/Layout";
import CommentsView from "../parts/main-page/CommentsView";
import VisitInfoView from "../parts/main-page/VisitInfoView";
import Hero from "../parts/main-page/Hero";
import Services from "../parts/main-page/Services";

export default function MainPage() {
    return (
        <Layout>
            <Hero/>
            <Services/>
            <VisitInfoView/>
            <CommentsView/>
        </Layout>
    );
}